import React from "react";
import { CATALOG } from "@/actions/catalog";

export enum ImportSourceType {
  Mycorr = "Mycorr",
  /// Houses every saved connection (postgres, supabase, google_oauth).
  /// Google Sheets is a `google_oauth` row inside this list, not a
  /// separate source.
  Connections = "Connections",
  Upload = "Upload",
}

type ImportSourceConfig = {
  label: string;
  icon: React.ReactNode;
  /** What the source holds and how a table comes in, under the source buttons. */
  description: string;
};

export const SOURCE_CONFIG: Record<ImportSourceType, ImportSourceConfig> = {
  [ImportSourceType.Mycorr]: {
    label: CATALOG.importMycorr.label,
    icon: <CATALOG.importMycorr.Icon className="w-5 h-5" />,
    description: "Tables from your models and the catalog.",
  },
  [ImportSourceType.Connections]: {
    label: CATALOG.importConnection.label,
    icon: <CATALOG.importConnection.Icon sx={{ fontSize: 20 }} />,
    description: "Tables from your databases and Google Sheets.",
  },
  [ImportSourceType.Upload]: {
    label: CATALOG.importFile.label,
    icon: <CATALOG.importFile.Icon sx={{ fontSize: 20 }} />,
    description: "CSV, Parquet or Excel files from your computer.",
  },
};

export const ALL_SOURCES = Object.values(ImportSourceType);
